import React, { FC, useEffect, useState } from "react";
import AutoCompleteInput from "../input/autoCompleteInput";
import DefaultLoader from "../loader";
import { Colors } from "@/styles/Colors";
import { debounce } from "@/utils/common";
import { getGeoData } from "@/utils/apis/auth/signup.api";
import { AutoCompleteProps } from "antd";
import { useAppContext } from "@/context";

type Props = {
  type:
    | "country"
    | "state"
    | "region"
    | "city"
    | "mineralGroup"
    | "subCollection"
    | "miningdistrict"
    | "mine"
    | "pocket"
    | "mineral";
  title: string;
  errorText?: boolean | string;
  onChange: (value: string) => void;
} & AutoCompleteProps;
const Search: FC<Props> = ({ type, title, errorText, onChange, ...rest }) => {
  const { user } = useAppContext();
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    []
  );
  const [page, setPage] = useState(0);
  const [query, setQuery] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  // fetch data
  const fetchAllData = async () => {
    try {
      console.log("type", type);
      if (!user?._id) return;
      setLoading(true);
      setPage(page + 1);
      const res = await getGeoData<{ name: string }[]>(type, {
        query,
        page: page + 1,
        addedBy: user?._id,
      });
      if (res.data.success) {
        const data = res.data.data;

        if (data.length === 0) {
          setHasMore(false);
        }

        setOptions([
          ...options,
          ...data.map((el) => ({
            label: el.name,
            value: el.name,
          })),
        ]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const searchData = async (query?: string) => {
    try {
      setLoading(true);
      const res = await getGeoData<{ name: string }[]>(type, {
        query,
        page: 1,
        addedBy: user?._id,
      });

      if (res.data.success) {
        const data = res.data.data;

        if (data.length === 0) {
          setHasMore(false);
        }

        setOptions(
          data.map((el) => ({
            label: el.name,
            value: el.name,
          }))
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = React.useCallback(
    debounce((value: string) => {
      searchData(value);
    }, 400),
    []
  );

  useEffect(() => {
    fetchAllData();
  }, [user?._id]);

  return (
    <AutoCompleteInput
      title={title}
      errorText={errorText}
      options={options}
      virtual={false}
      style={{
        border: "1px solid #f3f3f3",
        borderRadius: "5px",
      }}
      onSelect={onChange}
      suffixIcon={<DefaultLoader color={Colors.primary} active={loading} />}
      onSearch={(value) => {
        onChange(value);
        setQuery(value);
        debouncedSearch(value);
      }}
      bordered={false}
      onPopupScroll={(e) => {
        const { target } = e;
        if (
          (target as any).scrollTop + (target as any).offsetHeight ===
          (target as any).scrollHeight
        ) {
          if (hasMore) {
            fetchAllData();
          }
        }
      }}
      {...rest}
    />
  );
};

export default Search;
